module.exports = __webpack_public_path__ + "img/logo.fe2642e5.png";